import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import GetFreeEstimateButton from './GetFreeEstimateButton';
import useRetellWidget from '../hooks/useRetellWidget';

const { FiX } = FiIcons;

const StickyEstimate = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const { openWidget } = useRetellWidget();

  useEffect(() => {
    const handleScroll = () => {
      const scrolled = window.scrollY;
      const windowHeight = window.innerHeight;
      // Show button after scrolling past first screen
      setIsVisible(scrolled > windowHeight * 0.5 && !isDismissed);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isDismissed]);

  const handleDismiss = (e) => {
    e.stopPropagation();
    setIsDismissed(true);
    setIsVisible(false);
  };

  const handleEstimateClick = (e) => {
    e.preventDefault();
    console.log("[StickyEstimate] Direct click handler triggered");
    openWidget();
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-40"
        >
          <div className="relative">
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={handleEstimateClick}
              className="bg-blue-600 text-white px-8 py-4 text-lg font-semibold rounded-full shadow-lg hover:bg-blue-700 transition-colors flex items-center space-x-2"
              data-open-retell="true"
            >
              <span>Get Free Estimate</span>
            </motion.button>
            <button
              onClick={handleDismiss}
              className="absolute -top-2 -right-2 bg-gray-600 text-white p-1 rounded-full hover:bg-gray-700 transition-colors"
            >
              <SafeIcon icon={FiX} className="w-3 h-3" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default StickyEstimate;